import { c as _c } from "react/compiler-runtime";
import { transformSecondsToHoursAndMinutes } from '@systemeio/components';
import { PlusIcon } from '@systemeio/icons';
import { deleteFunnelEmail, FUNNEL_EMAIL_API } from 'modules/funnels/funnel/components/email-tab/api/funnel-email-api';
import { FunnelEmailsApiInterface, FunnelEmailsInterface } from 'modules/funnels/funnel/components/email-tab/types/funnel-emails-interface';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import React from 'react';
import { Button, Hint } from 'shared/components';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { convertSecondsToTimeValue } from 'shared/components/date-picker/time-delay-picker/utils';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import { LimitType, PaginationInterface } from 'shared/types/pagination-interface';
interface FunnelEmailTableProps {
  emails?: FunnelEmailsApiInterface;
  funnelStepId?: FunnelStepId;
  setPagination: React.Dispatch<React.SetStateAction<PaginationInterface>>;
  setLimit: React.Dispatch<React.SetStateAction<LimitType>>;
  limit: LimitType;
  pagination: PaginationInterface;
  onCreate: () => void;
  onEdit: (email: FunnelEmailsInterface) => void;
}
const FunnelEmailTable = t0 => {
  const $ = _c(76);
  const {
    emails,
    funnelStepId,
    setPagination,
    setLimit,
    limit,
    pagination,
    onCreate,
    onEdit
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = `${FUNNEL_EMAIL_API}/${funnelStepId}/webinar/emails`;
  let t2;
  if ($[0] !== setPagination || $[1] !== t1) {
    t2 = {
      api: t1,
      setPagination
    };
    $[0] = setPagination;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const updateData = useUpdateData(t2);
  let t3;
  if ($[3] !== emails || $[4] !== updateData) {
    t3 = async email => {
      await deleteFunnelEmail(email.webinarNotification.id);
      await updateData(false, emails);
    };
    $[3] = emails;
    $[4] = updateData;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const deleteEmail = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PlusIcon />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("global.create");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onCreate || $[10] !== t5) {
    t6 = <Button onClick={onCreate} variant="primary" size="sm">{t4}{t5}</Button>;
    $[9] = onCreate;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const createButton = t6;
  let t7;
  if ($[12] !== t) {
    t7 = t("global.event_caption");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = email_0 => {
      const time = transformSecondsToHoursAndMinutes(email_0.webinarNotification.certainTime);
      const delay = convertSecondsToTimeValue(email_0.webinarNotification.delay);
      return <div className="flex gap-2"><Hint label={<div className="flex flex-col items-start">{delay && <span>{t("dashboard.funnel.emails_webinar.delay")}:{" "}{`${delay.timeValue} ${t(delay.name)}`}</span>}{email_0.webinarNotification.certainTime && <span className="pb-2">{t("dashboard.funnel.emails_webinar.certain_time")}: {time.hours}:{time.minutes}</span>}<span>{t("dashboard.funnel.emails_webinar.number_of_sent_emails")}:{" "}{email_0.mailingStats.sentAmount}</span><span>{t("dashboard.funnel.emails_webinar.opened_emails")}:{" "}{email_0.mailingStats.openedAmount}</span><span>{t("dashboard.funnel.emails_webinar.count_of_click")}:{" "}{email_0.mailingStats.clickedAmount}</span></div>} /><div className="truncate"><span className="w-full">{email_0.webinarNotification.event === "webinar_start" ? email_0.webinarNotification.delay < 0 ? `${t("dashboard.funnel.emails_webinar_start_before")} ` : `${t("dashboard.funnel.emails_webinar_start_after")} ` : ""}{t(`dashboard.funnel.emails_${email_0.webinarNotification.event}`)}</span></div></div>;
    };
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = {
      key: "mailingStats",
      header: t7,
      widthPercent: 73,
      onRender: t8
    };
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("global.title_caption");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = {
      key: "webinarNotification",
      header: t10,
      widthPercent: 73,
      onRender: _temp
    };
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t9) {
    t12 = [t9, t11];
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const columns = t12;
  let t13;
  if ($[26] !== t) {
    t13 = t("dashboard.funnel.emails");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = <h2 className="capitalize">{t13}</h2>;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== createButton || $[31] !== t14) {
    t15 = <div className="flex items-center justify-between gap-5">{t14}{createButton}</div>;
    $[30] = createButton;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t) {
    t16 = t("dashboard.funnel.title");
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== limit || $[36] !== setLimit) {
    t17 = {
      limit,
      setLimit
    };
    $[35] = limit;
    $[36] = setLimit;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== pagination || $[39] !== setPagination) {
    t18 = {
      pagination,
      setPagination
    };
    $[38] = pagination;
    $[39] = setPagination;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t) {
    t19 = t("dashboard.funnel.email.empty.title");
    $[41] = t;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t) {
    t20 = t("dashboard.funnel.email.empty.description");
    $[43] = t;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== createButton || $[46] !== t19 || $[47] !== t20) {
    t21 = {
      title: t19,
      description: t20,
      children: createButton
    };
    $[45] = createButton;
    $[46] = t19;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t) {
    t22 = t("dashboard.funnel.emails_webinar.edit_send_email");
    $[49] = t;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== onEdit || $[52] !== t22) {
    t23 = {
      name: "edit-send-email",
      caption: t22,
      onActionClick: onEdit
    };
    $[51] = onEdit;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t) {
    t24 = t("dashboard.funnel.emails_webinar.remove_email");
    $[54] = t;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== deleteEmail || $[57] !== t) {
    t25 = (opened, onClose, instance, key) => <ConfirmationModal status="error" key={key} toastCaption={t("dashboard.funnel.emails_webinar.email_delete_success")} confirmationText={t("dashboard.funnel.emails_webinar.modal_delete_confirm")} opened={opened} onClose={onClose} onConfirm={() => deleteEmail(instance)} />;
    $[56] = deleteEmail;
    $[57] = t;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t24 || $[60] !== t25) {
    t26 = {
      name: "delete-email",
      caption: t24,
      onActionRender: t25
    };
    $[59] = t24;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== t23 || $[63] !== t26) {
    t27 = {
      custom: [t23, t26]
    };
    $[62] = t23;
    $[63] = t26;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== columns || $[66] !== emails || $[67] !== t16 || $[68] !== t17 || $[69] !== t18 || $[70] !== t21 || $[71] !== t27) {
    t28 = <Table data={emails} getRowId={_temp2} columns={columns} caption={t16} limiter={t17} paginator={t18} emptyStateProps={t21} testAttributePostfix="emails" actions={t27} />;
    $[65] = columns;
    $[66] = emails;
    $[67] = t16;
    $[68] = t17;
    $[69] = t18;
    $[70] = t21;
    $[71] = t27;
    $[72] = t28;
  } else {
    t28 = $[72];
  }
  let t29;
  if ($[73] !== t15 || $[74] !== t28) {
    t29 = <>{t15}{t28}</>;
    $[73] = t15;
    $[74] = t28;
    $[75] = t29;
  } else {
    t29 = $[75];
  }
  return t29;
};
export default FunnelEmailTable;
function _temp(email_1) {
  return <div className="truncate"><span className="w-full">{email_1.webinarNotification.mailing.currentEmail.subject}</span></div>;
}
function _temp2(row) {
  return row.webinarNotification.id;
}